module.exports = __webpack_public_path__ + "img/查询统计select.eb02b385.svg";